<template>
  <f7-popup id="popup-profile" class="popup-profile">
    <f7-view>
      <f7-page>
        <f7-navbar>
          <f7-nav-left>
            <span class="popup-profile-title">
              {{ $t(`page_profile.title`) }}
            </span>
          </f7-nav-left>
          <f7-nav-right>
            <f7-link
              icon-f7="xmark"
              icon-color="blue"
              @click="$f7.popup.close()"
            ></f7-link>
          </f7-nav-right>
        </f7-navbar>

        <div class="page-content-inner">
          <f7-block-title v-if="user && user.id">
            <!-- {{ $t(`page_profile.personal_data`) }} -->
            {{ `${user.status.image}&nbsp; ${user.name} ${user.lastName}` }}
          </f7-block-title>
          <f7-list v-if="user && user.id" inline-labels no-hairlines>
            <!-- <f7-list-input
              type="text"
              readonly
              :label="$t(`form_fields.name.placeholder`)"
              :value="user.name"
            ></f7-list-input>

            <f7-list-input
              type="text"
              readonly
              :label="$t(`form_fields.last_name.placeholder`)"
              :value="user.lastName"
            ></f7-list-input>

            <f7-list-input
              type="email"
              readonly
              :label="$t(`form_fields.email.placeholder`)"
              :value="user.email"
            ></f7-list-input> -->

            <f7-list-item link="/profile-settings">
              <span slot="title">
                <f7-icon>✍️</f7-icon>&nbsp;&nbsp;
                {{ $t(`page_profile.profile_setting`) }}
              </span>
            </f7-list-item>

            <f7-list-item
              smart-select
              :smart-select-params="{
                closeOnSelect: true,
                pageBackLinkText: $t(`back`)
              }"
            >
              <span slot="title">
                <f7-icon>🌎</f7-icon>&nbsp;&nbsp;
                {{ $t(`language`) }}
              </span>
              <select :name="$t(`language`)" @change="changeLocale">
                <option
                  v-for="(locale, index) in locales"
                  :key="index"
                  :value="locale.shortName"
                  :selected="locale.shortName === selectedLocale"
                >
                  {{ locale.fullName }}
                </option>
              </select>
            </f7-list-item>

            <f7-list-item
              v-if="timezones.length"
              smart-select
              :smart-select-params="{
                closeOnSelect: true,
                pageBackLinkText: $t(`back`)
              }"
            >
              <span slot="title">
                <f7-icon>🕑</f7-icon>&nbsp;&nbsp; Timezone
              </span>
              <select @change="changeTimezone">
                <option
                  v-for="timezone in timezones"
                  :key="timezone.id"
                  :value="timezone.id"
                  :selected="user.timezone.id === timezone.id"
                >
                  {{ timezone.label }}
                </option>
              </select>
            </f7-list-item>
          </f7-list>

          <f7-block-title v-if="user && user.id">
            {{ $t(`page_profile.others`) }}
          </f7-block-title>

          <f7-list no-hairlines>
            <f7-list-item
              v-for="(term, index) in terms"
              :key="index"
              :title="term[$i18n.locale].name"
              :link="term[$i18n.locale].link"
              external
              target="_blank"
            ></f7-list-item>
          </f7-list>

          <f7-list v-if="user && user.id" class="mt-auto" no-hairlines>
            <f7-list-item
              :title="$t(`log_out`)"
              class="text-color-red"
              @click="logOut"
            ></f7-list-item>
          </f7-list>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import apiRequest from '../js/helpers/apiRequest.js';
import removeTokenFromLocalStorage from '@/js/helpers/removeTokenFromLocalStorage.js';

import {
  setUserLanguageToLocalStorage,
  setI18nLocale
} from '@/js/helpers/languageUtils.js';

export default {
  name: 'Profile',

  data() {
    return {
      dialogId: null,
      timezones: []
    };
  },

  computed: {
    selectedLocale() {
      return localStorage.getItem('lang')
        ? localStorage.getItem('lang')
        : localStorage.getItem('nativeLang');
    },

    ...mapState({
      user: (state) => state.user.info,
      lesson: (state) => state.lesson.lesson,
      locales: (state) => state.locales,
      terms: (state) => state.terms
    })
  },

  created() {
    apiRequest('timezones', 'GET').then((res) => {
      if (res.success) {
        this.timezones = res.success.timezones;
      }
    });
  },

  methods: {
    changeLocale(e) {
      const lang = e.target.value;

      setUserLanguageToLocalStorage('lang', lang);
      setI18nLocale(lang);
    },

    changeTimezone(e) {
      const timezoneId = e.target.value;

      const body = new FormData();
      body.append('timezone_id', timezoneId);

      apiRequest('set/timezone', 'POST', body, true).then(() => {
        this.$store.dispatch('user/getUserInfo');
      });
    },

    logOut() {
      this.$f7.dialog.confirm(
        this.$t(`page_profile.want_sign_out`),
        this.$t(`log_out`),
        async () => {
          await this.$echo.leave(`user.${this.user.id}`);

          removeTokenFromLocalStorage();
          this.setUserInfo({});
          this.$f7.popup.close();
          this.$f7.loginScreen.open('#loginScreen');
        }
      );
    },

    ...mapActions({
      finishLesson: 'lesson/finishLesson'
    }),

    ...mapMutations({
      setUserInfo: 'user/SET_USER_INFO'
    })
  }
};
</script>

<style lang="less">
.popup-profile {
  &-title {
    margin-left: 8px;
    font-size: 25px;
    font-weight: 500;
  }

  .list {
    --f7-input-placeholder-color: #9b9b9b;
    --f7-list-item-min-height: 40px;
    --f7-input-height: var(--f7-list-item-min-height);

    .item-content {
      padding-right: var(--f7-list-item-padding-horizontal);
    }

    .item-inner {
      padding-right: 0;
      border-bottom: 1px solid#d5d8dd;

      &::before {
        right: 0;
      }

      &::after {
        display: none;
      }
    }

    .item-after {
      margin-right: 15px;
    }

    .item-input-wrap {
      input {
        text-align: right;
      }
    }

    + .block-title {
      margin-top: 5px;
    }
  }

  .smart-select-page {
    .list {
      ul {
        &::before,
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
